import React, { useCallback, useRef } from 'react';
import moment from 'moment';
import Filter from '@/pages/dashboard/components/NewFilter';
import { setBtnPointLog, formatFilterValues } from "@/pages/dashboard/utils/utils";
import { filterValueType, InputItemType } from '../../components/NewFilter/_type';
import useOutSelector from '@/pages/dashboard/hooks/useOutSelector';

// 筛选器路径
const FILTER_PATH = 'realtime/revenue';

/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */

const RealtimeRevenueFilter = (props: any) => {
  const {
    path,
    filterConfirm,
    filterReset,
    filterInit,
    buttonLogConfig,
    openSticky = false,
    children,
    isHaveFilterSave = true,
    timeZone = 0,
  } = props;
  const filterValueRef = useRef<any>(null); // 筛选器值，此处不用state，更新formValue同样会触发组件更新
  const { selectorApi, selectorData, selectorLoading } = useOutSelector(props);
  // 设置inputList
  const inputList = [
    {
      type: 'singleDaily',
      key: 'singleDaily',
      default: moment().utcOffset(timeZone).format('YYYY-MM-DD'), // 根据时区设置默认值
    },
    {
      type: 'contrastDaily',
      key: 'contrastDaily',
      default: moment().utcOffset(timeZone).subtract(7, 'day').format('YYYY-MM-DD'),
    },
  ];

  const checkDateChange = (value: filterValueType, inputList: Array<InputItemType>) => {
    const singleDaily = inputList.find((item: any) => item?.key === 'singleDaily');
    const contrastDaily = inputList.find((item: any) => item?.key === 'contrastDaily');
    return value?.singleDaily !== singleDaily?.default || value?.contrastDaily !== contrastDaily?.default;
  };

  // 私有化处理，抹平新旧筛选器的差距
  const onInit = useCallback((value: filterValueType, inputList: Array<InputItemType>) => {
    filterValueRef.current = value;
    // todo 锁定状态下如果锁定时间跟默认时间相同，是否需要单独处理，设置diff为false？
    filterInit({
      ...formatFilterValues(value),
      timeDiff: checkDateChange(value, inputList),
    });
  }, [filterInit]);

  const onConfirm = useCallback((value: filterValueType, inputList: Array<InputItemType>) => {
    filterValueRef.current = value;
    const obj: any = {
      ...formatFilterValues(value),
      timeDiff: checkDateChange(value, inputList),
    };

    filterConfirm(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj);
  }, [filterConfirm]);

  const onReset = useCallback((value: filterValueType) => {
    filterValueRef.current = value;
    const obj = {
      ...formatFilterValues(value),
      timeDiff: false
    };
    filterReset(obj);
    // 打点，沟通后打点操作放在业务代码的confirm和reset中，不封装在新版本筛选器中
    setBtnPointLog(buttonLogConfig, obj, true);
  }, [filterReset]);

  return <Filter
    // pc_inflexion的realtime revenue页面，不做筛选器保存功能
    isHaveFilterSave={isHaveFilterSave}
    openSticky={openSticky}
    path={path || FILTER_PATH}
    latestDateType={''}
    value={filterValueRef.current}
    inputList={inputList}
    onInit={onInit}
    onConfirm={onConfirm}
    onReset={onReset}
    // 外部传入selectorApi使用其他selector数据源
    {...(selectorApi ? {
      outSelector: selectorData,
      loading: selectorLoading,
    } : {})}
  >
    {children}
  </Filter>;
};

export default RealtimeRevenueFilter;
